import { lazy, type ComponentType, type LazyExoticComponent } from 'react';

const RELOAD_KEY = 'spa-chunk-reload';

export function isChunkLoadError(error: unknown): boolean {
  const message =
    error instanceof Error
      ? error.message
      : typeof error === 'string'
        ? error
        : String(error ?? '');
  return /failed to fetch dynamically imported module|loading chunk|importing a module script failed|error loading dynamically imported module/i.test(
    message,
  );
}

export function reloadOnceForStaleChunk(): boolean {
  if (sessionStorage.getItem(RELOAD_KEY) === '1') return false;
  sessionStorage.setItem(RELOAD_KEY, '1');
  window.location.reload();
  return true;
}

export function clearChunkReloadFlag(): void {
  sessionStorage.removeItem(RELOAD_KEY);
}

export function lazyRetry<T extends ComponentType<unknown>>(
  factory: () => Promise<{ default: T }>,
): LazyExoticComponent<T> {
  return lazy(() =>
    factory().catch((error: unknown) => {
      if (isChunkLoadError(error) && reloadOnceForStaleChunk()) {
        return new Promise<{ default: T }>(() => {
          /* page is reloading */
        });
      }
      throw error;
    }),
  );
}
